import { useHistory } from 'react-router-dom';
import { Link } from '../../../../Devon/Components/InkyLink';
import './ProductItem.scss';
import ProductPoster from '../../../InkyPenUIKit/ProductPoster/ProductPoster';
import { ReadOrPurchaseButton } from '../../Series/ComicInfo/Volume/VolumeItem';
import React, { JSX, useMemo } from 'react';
import { Product } from '../../../../Models/Product';
import { useAtomValue } from 'jotai';
import { AccountInfoAtom, LoginStatusAtom } from '../../../../store/AccountStore';
import { AddToCartAction } from '../../../../store/CartStore';
import { Variant } from '../../../../Models/Product/Variant';
import { ReactComponent as Chevron } from '../../../Assets/inky-icons/Chevron_InkyPen.svg';
import InkyPenProgressBar from '../../../InkyPenUIKit/InkyPenProgressBar/InkyPenProgressBar';
import { useAtom, useSetAtom } from 'jotai/index';
import { SubscriptionStatusType } from '../../../../Models/AccountInfo';
import { isSubscribed } from '../../../Hooks/AuthUtils';
import { SubscriptionModalAtom } from '../../../SubscriptionModal/SubscriptionModalAtom';
import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import localeData from 'dayjs/plugin/localeData';
import clsx from 'clsx';
import { LoginOverlayVisible } from '../../../../store/OverlayStore';

dayjs.extend(LocalizedFormat);
dayjs.extend(localeData);


interface ProductItemProps {
    product: Product;
    includeSeriesName?: boolean;
    fromWheels?: boolean;
    showChapters?: boolean;
    hasChapters?: boolean;
}

export function ProductItem({
                                product,
                                includeSeriesName = false,
                                fromWheels,
                                showChapters = false,
                                hasChapters = false,
                            }: ProductItemProps) {
    const [AccountInfo] = useAtom(AccountInfoAtom);
    const defaultVariant = product.getDefaultVariant();
    const printVariant = product.getPrintVariant();
    const digitalVariant = product.getDigitalVariant();
    const digitalSale = digitalVariant?.priceType === 'Paid' && digitalVariant?.isOnSale;
    const printSale = printVariant?.priceType === 'Paid' && printVariant?.isOnSale;
    const loginStatus = useAtomValue(LoginStatusAtom);
    const history = useHistory();
    const loginOverlay = useSetAtom(LoginOverlayVisible);
    const setSubscriptionModal = useSetAtom(SubscriptionModalAtom);

    const isForRegistered = useMemo(() => digitalVariant?.priceType === 'FreeForRegistered', [digitalVariant]);

    function RenderPriceType({ margin }) {
        return <div className='price-grid'>
            {printVariant !== null && <div className='price-grid-item'>
                <span className={`print-digital-type ${hasChapters ? 'print-digital-type-has-chapters' : ''}`}>
                        PRINT EDITION
                    </span>
                <div className='prices-wrapper'>
                    {printVariant?.fullPrice &&
                        <span
                            className={`${printSale ? 'price-sale' : 'price'}`}>${printVariant?.fullPrice.toFixed(2)}</span>}
                    {printSale &&
                        <span className='discount-price'>${printVariant?.discountPrice.toFixed(2)}</span>
                    }
                </div>

                <AddedToCartTag margin={margin} product={product} variant={printVariant} />

                <div
                    className={`actions ${!printVariant?.fullPrice && 'actions-margin'} ${(printVariant?.priceType === 'FreeForRegistered') && 'print-depends-on-free-on-registered'}`}>
                    <ReadOrPurchaseButton product={product}
                                          showIfDisabled
                                          onClick={() => history.push('/product/' + (product.readableUrl ?? product.id))}
                                          variant={printVariant} />
                </div>

                {/*<span className='shipping-calculated'>*/}
                {/*    *Shipping calculated during checkout*/}
                {/*</span>*/}
            </div>}

            {digitalVariant !== null && <div className='price-grid-item'>
                {/*<span className={`print-digital-type ${hasChapters ? 'print-digital-type-has-chapters' : ''}`}>*/}
                {/*      DIGITAL EDITION*/}
                {/*</span>*/}

                <div className='prices-wrapper'>
                    {digitalVariant?.fullPrice &&
                        <span
                            className={`${digitalSale ? 'price-sale' : 'price'}`}>${digitalVariant?.fullPrice.toFixed(2)}</span>}
                    {digitalSale &&
                        <span className='discount-price'>${digitalVariant?.discountPrice.toFixed(2)}</span>
                    }

                    {isForRegistered && <div className={'price'}>Free with account</div>}
                </div>

                <AddedToCartTag margin={margin} product={product} variant={digitalVariant} />
                <div
                    className={`actions ${!digitalVariant?.fullPrice && 'actions-margin'} ${(isForRegistered && !product?.canReadDigitalByUser(loginStatus === 'LoggedIn')) && 'actions-free-for-registered'}`}>
                    <ReadOrPurchaseButton product={product}
                                          text={'Sign Up'}
                                          className={`${(isForRegistered && !product?.canReadDigitalByUser(loginStatus === 'LoggedIn')) && 'actions-free-for-registered-button'}`}
                                          showIfDisabled
                                          onClick={() => history.push('/product/' + (product.readableUrl ?? product.id))}
                    />
                </div>
            </div>}


        </div>;
    }

    function getReleaseDate() {
        let dates = [product?.publishDate, product?.readable?.digitalReleaseDate, product?.readable?.releaseDate, product?.readable?.printReleaseDate];
        dates = dates.filter(d => d != null);

        dates.sort((a, b) => a.diff(b));

        return dates[0];

    }

    const subscribed = useMemo(() => isSubscribed(AccountInfo), [AccountInfo]);
    const isFree = useMemo(() => product?.variants?.length > 0 ? product.variants[0]?.priceType === 'Free' : false, [product]);


    function hideDetails() {
        return product.subCategory === 'Episode';
    }

    return (
        <div className='product-item-column-wrapper'>
            <div className='product-item-wrapper'>
                <div
                    className={`product-item-free-poster-wrapper ${clsx(!hideDetails() && 'product-item-free-poster-wrapper-product-hover')}`}>
                    {isFree && <div className='sale-bug'>
                        Free
                    </div>}
                    {hideDetails() && (
                        <ProductPoster alt={product.name} preloadImage={false} src={product.thumbnails[0]?.url}
                                       hover={false} />
                    )}
                    {!hideDetails() && (
                        <Link to={'/product/' + (product.readableUrl ?? product.id)}>
                            <ProductPoster alt={product.name} preloadImage={false} src={product.thumbnails[0]?.url}
                                           hover={false} />
                        </Link>
                    )}
                </div>
                <div className='info-wrapper'>
                    <div
                        className={`product-subscribe-wrapper ${subscribed ? 'product-subscribe-wrapper-long' : ''}`}>
                        <div className='product-volume-number-wrapper'>
                            <span className='product-volume-title'>{product.series?.title}</span>
                            {hideDetails() && (
                                <>
                                    {includeSeriesName && product.series !== null && (
                                        <span className='series-name'>{product.series.title}</span>
                                    )}
                                    {product.subCategory === 'Episode' ?
                                        <span
                                            className='product-name'>Episode {product.readable.releaseDate.format(dayjs().localeData().longDateFormat('L'))}</span> :
                                        <span className='product-name'>{product.relativeName}</span>}
                                </>
                            )}
                            {!hideDetails() && (
                                <Link className='info-wrapper-title'
                                      to={hideDetails() ? null : '/product/' + (product.readableUrl ?? product.id)}>
                                    {includeSeriesName && product.series !== null && (
                                        <span className='series-name'>{product.series.title}</span>
                                    )}
                                    <span className='product-name'>{product.relativeName}</span>
                                </Link>
                            )}


                        </div>
                    </div>

                    {product?.readable?.pageCount && <span className='product-volume-page-text'>
                        {product.readable.pageCount} pages
                    </span>}

                    <div className='product-subscribe-details-wrapper'>
                        <span className='product-volume-subscribe-text'>
                            Read with InkyPen on Nintendo Switch™
                        </span>
                    </div>

                    {/*<div className='date-price-wrapper'>*/}
                    {/*    /!*<span className='date-pages'>{convertDate(product.publishDate)}</span>*!/*/}
                    {/*    <span className='date-price-divider'>|</span>*/}
                    {/*    {product.readable?.pageCount &&*/}
                    {/*        <span*/}
                    {/*            className='date-pages'>{convertDate(getReleaseDate()) != "Jan. 01, 1970" ? convertDate(getReleaseDate()) + " | " : ""  }{product.readable.pageCount} pages</span>}*/}

                    {/*    /!*<span className=''>Buy Digital Edition</span>*!/*/}
                    {/*</div>*/}
                    {/*<span className='details-text'> <Link*/}
                    {/*    to={'/product/' + (product.readableUrl ?? product.id)}>DETAILS</Link></span>*/}
                    {/*<Link to={'/product/' + (product.readableUrl ?? product.id)} className={'underline-wrapper'}>*/}
                    {/*    <InkyPenUnderlinedText text={'Details'} />*/}
                    {/*</Link>*/}
                    {/*<div*/}
                    {/*    className={`price-grid-desktop ${hasChapters ? 'hide-on-show-chapters' : ''}*/}
                    {/*     ${(hasChapters && isForRegistered) ? 'hide-on-show-chapters-free-for-registered' : ''}*/}
                    {/*     ${fromWheels && 'hide-on-wheels'}*/}
                    {/*     ${(fromWheels && (printVariant === null || defaultVariant === null) ? 'price-grid-desktop-one-variant' : '')}`}>*/}
                    {/*    <RenderPriceType margin={showChapters}/>*/}
                    {/*</div>*/}
                    {/*Someone good at css please style this */}
                </div>
            </div>

            {!hideDetails() && <div className='read-subscribe-details-grid'
                                    style={hideDetails() ? { gridTemplateColumns: 'auto' } : {}}>
                {/*<div className='read-subscribe-details-button'>*/}
                {/*    {(subscribed || isFree) ? <RenderPriceType margin={hideDetails() ? true : showChapters} /> :*/}
                {/*        <span className='subscribe-button'*/}
                {/*              onClick={() => {*/}
                {/*                  if (loginStatus === 'LoggedIn') {*/}
                {/*                      setSubscriptionModal(true);*/}
                {/*                      return;*/}
                {/*                  }*/}
                {/*                  loginOverlay(true);*/}
                {/*              }}>Subscribe</span>}*/}
                {/*</div>*/}

                {!hideDetails() && <div className='view-details-wrapper'>
                    <Link to={'/product/' + product.id} className='view-details-text'>
                        Details
                    </Link>
                    <Chevron className='view-details-icon' />
                </div>}
            </div>}

            {/*<div*/}
            {/*    className={`price-grid-mobile*/}
            {/*     ${hasChapters ? 'show-on-show-chapters' : ''}*/}
            {/*     ${(hasChapters && isForRegistered) ? 'show-on-show-chapters-free-for-registered' : ''}*/}
            {/*     ${fromWheels && 'show-on-wheels'}`}>*/}
            {/*    <RenderPriceType margin={true} />*/}
            {/*</div>*/}
        </div>
    );
}

function AddedToCartTag({ margin, product, variant }:
                            {
                                margin: boolean,
                                product: Product,
                                variant: Variant
                            }) {
    const cart = useAtomValue(AddToCartAction);

    if (!cart) return <></>;

    const amount = cart.amountOfProductVariant(product, variant);

    if (cart.containsProductVariant(product, variant)) {
        return <span className={`added-to-cart ${margin ? 'added-to-cart-open' : ''}`}>
                    Added to cart {amount > 1 ? `(${amount})` : ''}
                </span>;
    }

    return (
        <></>
    );

}